export default __webpack_public_path__ + "static/media/block.268cbf68.svg";